import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const UtilsStore = {
  state: {},
  getters,
  mutations,
  actions
}

export default UtilsStore
